var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"errorPage"}},[_c('div',{staticClass:"container"},[_c('font-awesome-icon',{attrs:{"icon":_vm.fontAwesomeIcon,"size":"6x"}}),_c('p'),_c('h1',[_vm._v(_vm._s(_vm.errorMessage))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }